import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import SelloAguaSolicitud from "/src/assets/images/sello_soc.png";
import LogoPdf from "/src/assets/images/logo.jpg";

import {
  decodeBase64Image,
  DIRECCION_EMPRESA_SALMONES_DE_CHILE,
  FORMAT_CURRENCY,
  FORMAT_DATETIME_DDMMYYYY,
  GIRO_EMPRESA_SALMONES_DE_CHILE,
  TELEFONO_EMPRESA_SALMONES_DE_CHILE,
} from "../../utils/Constants";

const dataHead = {
  title: "Solicitud de Orden Compra",
  company: "SALMONES DE CHILE Y PRODUCTORA S.A",
  rut: "RUT: 99.520.820-2",
  giro: GIRO_EMPRESA_SALMONES_DE_CHILE,
  direccion: DIRECCION_EMPRESA_SALMONES_DE_CHILE,
  telefonos: TELEFONO_EMPRESA_SALMONES_DE_CHILE,
  logo: LogoPdf,
};

interface CreatePdfTableProps {
  data: any;
  initData: any;
  solicitudesApprovalStates: any[];
  solicitudesSignApprovalHistory: any[];
}

function CreatePdfTable({
  data,
  initData,
  solicitudesApprovalStates,
  solicitudesSignApprovalHistory,
}: CreatePdfTableProps) {
  const handleGenerate = () => {
    const maxPageHeight = 279;
    const maxPageWidth = 216;
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [maxPageHeight, maxPageWidth],
      compress: true, // This is crucial
    });
    const documentStyle = getComputedStyle(document.documentElement);

    //********************************************************************************************/
    /**************************** HEADER DE SOLICITUD DE ORDEN DE COMPRA *************************/
    try {
      const img = new Image();
      img.src = dataHead.logo;
      img.onload = async function () {
        doc.setFontSize(10);
        //HEAD IZQUIERDA
        doc.text(dataHead.company, 5, 10);
        doc.text(dataHead.rut, 5, 15);
        doc.setFontSize(5);
        doc.text(dataHead.giro, 5, 20, { maxWidth: 70 });

        doc.text(dataHead.direccion, 5, 30);
        doc.text(dataHead.telefonos, 5, 35);

        doc.setFontSize(10);
        doc.text("Solicitante: " + data.nombres, 5, 50, { maxWidth: 65 });
        doc.text(
          "Centro solicitante: " + data.cc_id + "-" + data.cc_nombre,
          5,
          55,
          { maxWidth: 65 },
        );
        //HEAD CENTRO
        doc.addImage(img, "PNG", 95, 30, 20, 20, undefined, "FAST");
        doc.text(dataHead.title, 85, 50);
        doc.setFontSize(10);
        doc.text(
          "Tipo: " + data.subdoc_nombre + ", Estado: " + data.socest_nombre,
          80,
          55,
        );
        doc.setTextColor("red");
        doc.setFontSize(10);
        doc.text("N° " + data.soc_id, 104, 60);
        //********************************************************************************************/
        /**************************** HEADER DERECHA *****************************/
        doc.setTextColor("black");

        doc.text("Fecha creación: " + data.soc_dt_cre, 160, 10);

        doc.setFontSize(6);
        doc.text("Estado Operacional: " + data.estope_nombre, 160, 15);

        doc.text("Tipo Moneda: " + data.tipmon_nombre, 160, 20);

        doc.setFontSize(10);
        //********************************************************************************************/
        /**************************** BODY *****************************/
        //TABLA PRINCIPAL DE DETALLE DE LA SOLICITUD
        autoTable(doc, {
          startY: 70,
          styles: { halign: "center" },
          headStyles: {
            fillColor: documentStyle.getPropertyValue("--secondary-dark-color"),
            textColor: "white",
            halign: "center",
            fontSize: 9,
          },
          bodyStyles: { halign: "left", fontSize: 7 },
          tableLineWidth: 0.1,
          head: [
            [
              "Id",
              "Centro Costo",
              "Proveedor",
              "Item",
              "U.M",
              "Cantidad",
              "Precio Ref. Unitario",
              "Total",
              "Mes Gasto",
            ],
          ],
          body: data.detalle
            .filter(
              (row: { socest_id: number }) =>
                row.socest_id !== 2 && row.socest_id !== 4,
            )
            .map((val: any, i: number) => {
              const finalId = val.sdetcc2_id ?? val.sdetcc_id;
              const finalNombre = val.sdetcc2_nombre ?? val.sdetcc_nombre;

              return [
                i + 1,
                `${finalId} - ${finalNombre}`,
                `${val.prov_id} - ${val.prov_nombre}`,
                `${val.item_id} - ${val.item_nombre}`,
                val.um_codigo,
                val.socdet_cantidad,
                FORMAT_CURRENCY(val.socdet_precio_unitario_ref),
                FORMAT_CURRENCY(val.socdet_precio_total_ref),
                data.meses_nombre,
              ];
            }),
          columnStyles: {
            0: { cellWidth: 8 },
            1: { cellWidth: 30 },
            2: { cellWidth: 30 },
            3: { cellWidth: 34 },
            4: { cellWidth: 10 },
            5: { cellWidth: 12 },
            6: { cellWidth: 20 },
            7: { cellWidth: 27 },
            8: { cellWidth: 17 },
          },
        });

        // @ts-ignore
        let finalYTableOne = doc.canvas.pdf.lastAutoTable.finalY;

        //SE CREA UNA NUEVA PAGINA SI QUEDA POCO ESPACIO EN LA PRIMERA
        if (finalYTableOne + 50 > maxPageHeight) {
          doc.addPage();
        }

        //TABLA CON OBSERVACIONES DE LOS DETALLES
        autoTable(doc, {
          startY: finalYTableOne + 10,
          styles: { halign: "center" },
          headStyles: {
            fillColor: documentStyle.getPropertyValue("--secondary-dark-color"),
            textColor: "white",
            halign: "center",
            fontSize: 9,
          },
          bodyStyles: { halign: "left", fontSize: 7 },
          tableLineWidth: 0.1,
          head: [["Id", "Observaciones"]],
          body: data.detalle
            .filter(
              (row: { socest_id: number }) =>
                row.socest_id !== 2 && row.socest_id !== 4,
            )
            .map((val: any, i: number) => [i + 1, val.socdet_observaciones]),
          columnStyles: {
            0: { cellWidth: 15 },
            1: { cellWidth: 173 },
          },
        });

        // @ts-ignore
        let finalYTableTwo = doc.canvas.pdf.lastAutoTable.finalY;

        //SE CREA UNA NUEVA PAGINA SI QUEDA POCO ESPACIO EN LA PRIMERA
        if (finalYTableTwo + 70 > maxPageHeight) {
          doc.addPage();
          finalYTableTwo = 10;
        }
        doc.setFontSize(9);

        //********************************** PIE DE HOJA **************************************/
        //**************************** FIRMA SOLICITANTE ****************************************/
        doc.line(20, maxPageHeight - 50, 60, maxPageHeight - 50);
        doc.text("Solicitante", 30, maxPageHeight - 40);
        doc.setFontSize(7);
        doc.text(
          solicitudesApprovalStates[0].nombres +
            " " +
            solicitudesApprovalStates[0].apellidos,
          20,
          maxPageHeight - 35,
        );
        doc.setFontSize(9);
        doc.text(
          "Fecha solicitud: " +
            FORMAT_DATETIME_DDMMYYYY(
              solicitudesApprovalStates[0].fechaCreacion,
            ),
          20,
          maxPageHeight - 30,
        );

        let indexSubGte = solicitudesApprovalStates.length - 1;

        //********************************** FIRMA APROBADOR ****************************************/
        if (
          solicitudesApprovalStates[1] !== undefined &&
          solicitudesApprovalStates.length < 4
        ) {
          doc.line(80, maxPageHeight - 50, 120, maxPageHeight - 50);
          doc.text("Aprobador", 90, maxPageHeight - 40);

          doc.setFontSize(7);
          doc.text(
            solicitudesApprovalStates[1].nombres +
              " " +
              solicitudesApprovalStates[1].apellidos,
            75,
            maxPageHeight - 35,
          );

          doc.setFontSize(9);
          doc.text(
            "Fecha aprobación: " +
              FORMAT_DATETIME_DDMMYYYY(
                solicitudesApprovalStates[1].fechaCreacion,
              ),
            75,
            maxPageHeight - 30,
          );
          doc.setFontSize(5);
          doc.text(
            "Código Validador: " +
              solicitudesSignApprovalHistory[0].ufdhs_id_algoritmo,
            75,
            maxPageHeight - 25,
          );

          doc.setFontSize(9);
        }

        //AQUI ENTRA LA LOGICA DE ORDENES CON FIRMA DE TOTALES MAYORES A 2 millones, firma tanto gerente area como gerente general
        if (
          solicitudesApprovalStates[indexSubGte] !== undefined &&
          data.socest_id > 6
        ) {
          doc.line(140, maxPageHeight - 50, 180, maxPageHeight - 50);
          doc.text("Adquisición", 150, maxPageHeight - 40);

          doc.setFontSize(7);
          doc.text(
            solicitudesApprovalStates[indexSubGte].nombres +
              " " +
              solicitudesApprovalStates[indexSubGte].apellidos || "",
            140,
            maxPageHeight - 35,
          );

          doc.setFontSize(9);
          doc.text(
            "Fecha confirmación: " +
              FORMAT_DATETIME_DDMMYYYY(
                solicitudesApprovalStates[indexSubGte].fechaCreacion,
              ),
            140,
            maxPageHeight - 30,
          );
          doc.setFontSize(5);

          doc.text(
            "Código Validador: " +
              solicitudesSignApprovalHistory[indexSubGte - 1]
                .ufdhs_id_algoritmo,
            140,
            maxPageHeight - 25,
          );
          doc.setFontSize(9);
        }

        //Agregamos sello de agua al documento por cada página para indicar no es válido como orden de compra
        addWaterMark(
          doc,
          solicitudesApprovalStates,
          data.soc_id,
          maxPageHeight,
          data,
        );
      };
    } catch (error) {
      console.log("Error: ", error);
      throw new Error("Error generando pdf");
    }
  };

  try {
    handleGenerate();
  } catch (error) {
    console.log("ERROR:", error);
  }

  // Devolvemos null ya que este componente parece ser solo para ejecutar la lógica de PDF
  return null;
}

async function addWaterMark(
  doc: any,
  solicitudesApprovalStates: any,
  nroSolicitud: number,
  maxPageHeight: number,
  data: any,
) {
  var totalPages = doc.internal.getNumberOfPages();
  var img = new Image();
  img.src = SelloAguaSolicitud;

  img.onload = function () {
    var imgFirmaSolicita = new Image();
    var imgFirmaAprobador = new Image();
    var imgFirmaConfirmador = new Image();

    let indexSubGte = solicitudesApprovalStates.length - 1;

    imgFirmaSolicita.setAttribute(
      "src",
      "data:image/png;base64," +
        decodeBase64Image(solicitudesApprovalStates[0].firma),
    );

    if (
      solicitudesApprovalStates[1] !== undefined &&
      solicitudesApprovalStates.length < 4
    ) {
      imgFirmaAprobador.setAttribute(
        "src",
        "data:image/png;base64," +
          decodeBase64Image(solicitudesApprovalStates[1].firma),
      );
    }

    if (
      solicitudesApprovalStates[indexSubGte] !== undefined &&
      data.socest_id > 6
    ) {
      imgFirmaConfirmador.setAttribute(
        "src",
        "data:image/png;base64," +
          decodeBase64Image(solicitudesApprovalStates[indexSubGte].firma),
      );
    }

    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();

    //TRANSPARENCIA PARA LA IMAGEN DE AGUA
    for (var i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setGState(new doc.GState({ opacity: 0.1 }));

      doc.addImage(
        img,
        "PNG",
        45,
        90,
        width - 100,
        height - 200,
        undefined,
        "FAST",
      );
    }

    imgFirmaSolicita.onload = function () {
      //FIRMAS SOLO EN LA ULTIMA HOJA
      doc.setPage(totalPages);
      doc.setGState(new doc.GState({ opacity: 1 }));

      doc
        .addImage(imgFirmaSolicita, "PNG", 20, maxPageHeight - 80, 50, 40)
        .setFont(undefined, "bold");

      if (
        solicitudesApprovalStates[1] !== undefined &&
        solicitudesApprovalStates.length < 4
      ) {
        doc.addImage(imgFirmaAprobador, "PNG", 70, maxPageHeight - 80, 50, 40);
      }

      if (
        solicitudesApprovalStates[indexSubGte] !== undefined &&
        data.socest_id > 6
      ) {
        doc.addImage(
          imgFirmaConfirmador,
          "PNG",
          130,
          maxPageHeight - 80,
          50,
          40,
        );
      }

      doc.setTextColor(50);
      try {
        doc.setProperties({
          title: `SOC_${nroSolicitud}`,
        });

        const pdfBlob = doc.output("blob");
        const fileName = `SOC_${nroSolicitud}.pdf`;

        // 1. Detectar si es un dispositivo móvil o tablet
        const isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
          );

        if (isMobile) {
          // ESTRATEGIA PARA ANDROID / iOS
          // doc.save() fuerza la descarga. En móviles, esto suele abrir
          // automáticamente el selector de apps nativo para leer PDFs.
          doc.save(fileName);
        } else {
          // ESTRATEGIA PARA PC ESCRITORIO (Tu código original)
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const newTab = window.open("", "_blank") as Window | null;

          if (newTab) {
            newTab.document.title = `SOC_${nroSolicitud}`;
            newTab.document.body.style.margin = "0";
            newTab.document.body.style.overflow = "hidden";

            const iframe = newTab.document.createElement("iframe");
            iframe.src = pdfUrl;
            iframe.style.width = "100vw";
            iframe.style.height = "100vh";
            iframe.style.border = "none";

            newTab.document.body.appendChild(iframe);
          } else {
            alert(
              "Por favor, permite las ventanas emergentes para ver el PDF.",
            );
          }
        }
      } catch (error) {
        console.log("Error al generar pdf: ", error);
      }
      // -------------------------------------
    };
  };
}

export default CreatePdfTable;
